import { Button, Modal, Spin } from 'antd';

import { useUpdateSchoolDataMutation } from '@/api/endpoints/schools';
import { useApiRequest } from '@/shared/hooks';

import type { IUnpublishModalSchoolInfo } from './types';
import styles from './UnpublishSchoolModal.module.scss';

type TProps = {
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  schoolInfo: IUnpublishModalSchoolInfo | null | undefined;
};

export const UnpublishSchoolModal = ({ isModalOpen, handleCancel, schoolInfo }: TProps) => {
  const [updateSchoolData, { isLoading: isUpdatingSchoolData }] = useUpdateSchoolDataMutation();

  const sendApiRequest = useApiRequest();

  if (!schoolInfo) {
    return null;
  }

  if (schoolInfo) {
    const { id: schoolId, name: schoolName } = schoolInfo;

    const unPublishSchoolHandler = async () => {
      await sendApiRequest({
        successMessage: 'Школа снята с публикации',
        apiRequestCallback: () =>
          updateSchoolData({
            id: schoolId,
            data: {
              active: false,
            },
          }),
        successCallback: handleCancel,
      });
    };

    return (
      <Modal
        width={600}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <Spin spinning={isUpdatingSchoolData}>
          <div className={styles.wrapper}>
            <p className={styles.title}>Снятие с публикации</p>
            <p className={styles.description}>Вы уверены, что хотите снять школу "{schoolName}" c&nbsp;публикации?</p>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                disabled={isUpdatingSchoolData}
                onClick={unPublishSchoolHandler}
                className={styles.button}
                danger
              >
                Снять с публикации
              </Button>
              <Button
                size="large"
                onClick={handleCancel}
                type="primary"
                className={styles.button}
              >
                Отмена
              </Button>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
};
